import type React from 'react'

type Props = {
  size?: number
}

const IconChevronRight: React.FC<Props & React.SVGProps<SVGSVGElement>> = ({
  size = 16,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.85742 2.45312L11.0469 6.90625C11.1641 7.05273 11.252 7.22852 11.252 7.375C11.252 7.55078 11.1641 7.72656 11.0469 7.87305L6.85742 12.3262C6.59375 12.6191 6.1543 12.6191 5.86133 12.3555C5.56836 12.0918 5.56836 11.6523 5.83203 11.3594L9.58203 7.375L5.83203 3.41992C5.56836 3.12695 5.56836 2.6875 5.86133 2.42383C6.1543 2.16016 6.59375 2.16016 6.85742 2.45312Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconChevronRight
